export default __webpack_public_path__ + "static/media/bannerSuvinil.d255033d.jpg";